// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-bantanium-js": () => import("./../src/pages/bantanium.js" /* webpackChunkName: "component---src-pages-bantanium-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pottery-js": () => import("./../src/pages/pottery.js" /* webpackChunkName: "component---src-pages-pottery-js" */)
}

